<div *ngIf="qrUrl">
    <div class="overlay">
        &nbsp;
    </div>
    <div class="qr_image_container">
        <div class="info-box">
            <div class="row">
                <div class="col-5" style="text-align: right;">
                    <button class="button_icon" (click)="onAction(4)"
                        style="color: green !important;float: left;">refresh</button>
                    <app-label [Text]="localService.languageContent.common.amount" />
                </div>
                <div class="col-5">
                    <span class="en">{{(amount ?? 0).toFixed(2)}}</span>
                </div>
                <div class="col-2" style="text-align: right;">
                    <button class="button_icon" style="color: red;" (click)="onAction(1)">close</button>
                </div>
            </div>
            <div class="row">
                <div class="col-5" style="text-align: right;">
                    <app-label [Text]="localService.languageContent.common.ref_num" />
                </div>
                <div class="col-7">
                    <span class="en">{{referenceId}}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-5" style="text-align: right;">
                    <app-label [Text]="localService.languageContent.common.sender" />
                </div>
                <div class="col-7">
                    {{senderName}}
                    <button [id]="elementIds.success" *ngIf="isShowTestCallBack"
                        class="button_icon icon_adjust callback-icon" style="background-color: green !important;"
                        (click)="onAction(2)" title="{{localService.languageContent.common.success}}">done</button>
                </div>
            </div>
            <div class="row">
                <div class="col-5" style="text-align: right;">
                    <app-label [Text]="localService.languageContent.common.receiver" />
                </div>
                <div class="col-7">
                    <span>{{receiverName}}</span>
                    <button [id]="elementIds.failed" *ngIf="isShowTestCallBack"
                        class="button_icon icon_adjust callback-icon" style="background-color: red !important;"
                        (click)="onAction(3)" title="{{localService.languageContent.common.failed}}">clear</button>
                </div>
            </div>
        </div>
        <div class="qr_image_box">
            <img [src]="qrUrl" />
        </div>
    </div>
</div>
<div *ngIf="paymentUrl && sanitizedUrl" style="display: flex; justify-content: center;">
    <div class="overlay">
        &nbsp;
    </div>
    <div class="close_btn">
        <button class="button_icon" (click)="onAction(1)" style="background-color: red !important;
        border-radius: 50%; width: 45px;">close</button>
        <button class="button_icon" (click)="onAction(4)" style="background-color: green !important;
        border-radius: 50%; width: 45px;">refresh</button>
        <button [id]="elementIds.success" *ngIf="isShowTestCallBack" class="button_icon icon_adjust callback-icon"
            style="background-color: green !important;" (click)="onAction(2)"
            title="{{localService.languageContent.common.success}}">done</button>
        <button [id]="elementIds.failed" *ngIf="isShowTestCallBack" class="button_icon icon_adjust callback-icon"
            style="background-color: red !important;" (click)="onAction(3)"
            title="{{localService.languageContent.common.failed}}">clear</button>
    </div>
    <iframe *ngIf="paymentUrl" id="{{elementIds.payment_url}}"
        style="position: fixed;top: 0px;z-index: 1501;height: 100vh;" [src]="sanitizedUrl" (load)="onIframeLoad()">
    </iframe>
</div>